import { CardData } from "./card-data/card-data";
import { CardFuncEnums, cardFuncEnumToContainer } from "./card-data/card-functions";

// for now, startingHand and targetHand are just arrays from [1-9] ?

class StartCardShort {
  constructor(intVal, cardFuncEnum) {
    this.intVal = intVal;
    this.cardFuncEnum = cardFuncEnum;

  }
}

class LevelConfig {
  constructor(startCardsShort, targetHandInts) {
    this.startingHand = startCardsShort.map(x =>  {
      return new CardData(x.intVal, cardFuncEnumToContainer[x.cardFuncEnum]);
    });
    this.targetHandInts = targetHandInts;
  }
}

const level0 = new LevelConfig([
    new StartCardShort(1, CardFuncEnums.addToFront),
    new StartCardShort(2, CardFuncEnums.addToFront),
    new StartCardShort(3, CardFuncEnums.addToFront),
  ], 
  [6]);

const level1 = new LevelConfig([
  new StartCardShort(1, CardFuncEnums.addToFront),
  new StartCardShort(2, CardFuncEnums.addToFront),
  new StartCardShort(3, CardFuncEnums.addToFront),
  new StartCardShort(4, CardFuncEnums.addToFront),
  ], 
  [7,3]);

const level2_firstProd = new LevelConfig([
  new StartCardShort(4, CardFuncEnums.addToFront),
  new StartCardShort(4, CardFuncEnums.prodToBack),
  new StartCardShort(4, CardFuncEnums.addToFront),
  new StartCardShort(4, CardFuncEnums.prodToBack),
  new StartCardShort(4, CardFuncEnums.addToFront),
  ], 
  [12,16]);

const level2_secondProd = new LevelConfig([
  new StartCardShort(4, CardFuncEnums.addToFront),
  new StartCardShort(4, CardFuncEnums.prodToBack),
  new StartCardShort(4, CardFuncEnums.addToFront),
  new StartCardShort(4, CardFuncEnums.prodToBack),
  new StartCardShort(4, CardFuncEnums.addToFront),
  ], 
  [8,32]);

const level3_shiftOne = new LevelConfig([
  new StartCardShort(1, CardFuncEnums.addToFront),
  new StartCardShort(2, CardFuncEnums.prodToBack),
  new StartCardShort(1, CardFuncEnums.rightShift),
  new StartCardShort(3, CardFuncEnums.addToFront),
  new StartCardShort(4, CardFuncEnums.prodToBack),
  ], 
  [5,2,3]);

const level4_shiftTwo_2 = new LevelConfig([
  new StartCardShort(1, CardFuncEnums.addToFront),
  new StartCardShort(1, CardFuncEnums.prodToBack),
  new StartCardShort(0, CardFuncEnums.leftShift),
  new StartCardShort(1, CardFuncEnums.addToFront),
  new StartCardShort(3, CardFuncEnums.prodToBack),
  new StartCardShort(2, CardFuncEnums.addToFront),
  ], 
  [3,2,1]);

const level5_shift3_2 = new LevelConfig([
  new StartCardShort(1, CardFuncEnums.addToFront),
  new StartCardShort(1, CardFuncEnums.rightShift),
  new StartCardShort(10, CardFuncEnums.addToFront),
  new StartCardShort(100, CardFuncEnums.prodToBack),
  new StartCardShort(1, CardFuncEnums.leftShift),
  new StartCardShort(2, CardFuncEnums.prodToBack),
  new StartCardShort(3, CardFuncEnums.addToFront),
  ], 
  [510]);

const level6_shift4_again = new LevelConfig([
  new StartCardShort(1, CardFuncEnums.leftShift),
  new StartCardShort(1, CardFuncEnums.rightShift),
  new StartCardShort(2, CardFuncEnums.rightShift),
  new StartCardShort(2, CardFuncEnums.leftShift),
  new StartCardShort(3, CardFuncEnums.leftShift),
  new StartCardShort(3, CardFuncEnums.rightShift),
  ], 
  [1,2,3]);

const level7_negs = new LevelConfig([
  new StartCardShort(4, CardFuncEnums.addToFront),
  new StartCardShort(4, CardFuncEnums.prodToBack),
  new StartCardShort(-4, CardFuncEnums.addToFront),
  new StartCardShort(-4, CardFuncEnums.prodToBack),
  new StartCardShort(4, CardFuncEnums.addToFront),
  ], 
  [192]);

const level8_negs2 = new LevelConfig([
  new StartCardShort(2, CardFuncEnums.leftShift),
  new StartCardShort(-1, CardFuncEnums.prodToBack),
  new StartCardShort(3, CardFuncEnums.addToFront),
  new StartCardShort(-1, CardFuncEnums.addToFront),
  new StartCardShort(2, CardFuncEnums.rightShift),
  ], 
  [-1,2,3]);

const level9_id1 = new LevelConfig([
  new StartCardShort(37, CardFuncEnums.identity),
  new StartCardShort(81, CardFuncEnums.identity),
  new StartCardShort(4, CardFuncEnums.identity),
  new StartCardShort(37, CardFuncEnums.identity),
  new StartCardShort(12, CardFuncEnums.identity),
  new StartCardShort(1, CardFuncEnums.addToFront),
  ], 
  [38, 81, 12]);

const level10_id2 = new LevelConfig([
  new StartCardShort(1, CardFuncEnums.leftShift),
  new StartCardShort(1, CardFuncEnums.identity),
  new StartCardShort(2, CardFuncEnums.identity),
  new StartCardShort(2, CardFuncEnums.prodToBack),
  new StartCardShort(3, CardFuncEnums.identity),
  new StartCardShort(1, CardFuncEnums.addToFront),
  new StartCardShort(1, CardFuncEnums.rightShift),
  ], 
  [3,2,1]);
  
const level11_where1 = new LevelConfig([
  new StartCardShort(7, CardFuncEnums.addToFront),
  new StartCardShort(7, CardFuncEnums.addToFront),
  new StartCardShort(15, CardFuncEnums.addToFront),
  new StartCardShort(1, CardFuncEnums.addToFront),
  new StartCardShort(10, CardFuncEnums.whereLess),
  new StartCardShort(5, CardFuncEnums.addToFront),
  new StartCardShort(10, CardFuncEnums.addToFront),
  new StartCardShort(500, CardFuncEnums.addToFront)
  ], 
  [6]);

const level12_where2 = new LevelConfig([
  new StartCardShort(-2, CardFuncEnums.prodToBack),
  new StartCardShort(1, CardFuncEnums.rightShift),
  new StartCardShort(2, CardFuncEnums.whereLess),
  new StartCardShort(2, CardFuncEnums.identity),
  new StartCardShort(2, CardFuncEnums.whereGreater),
  new StartCardShort(2, CardFuncEnums.leftShift),
  new StartCardShort(2, CardFuncEnums.addToFront)
  ], 
  [2]);

const level13_dup1 = new LevelConfig([
  new StartCardShort(5, CardFuncEnums.addToFront),
  new StartCardShort(2, CardFuncEnums.duplicate),
  new StartCardShort(1, CardFuncEnums.addToFront)
  ], 
  [7,5]);

const level14_dup2 = new LevelConfig([
  new StartCardShort(1, CardFuncEnums.addToFront),
  new StartCardShort(1, CardFuncEnums.rightShift),
  new StartCardShort(10, CardFuncEnums.identity),
  new StartCardShort(1, CardFuncEnums.duplicate), 
  new StartCardShort(1, CardFuncEnums.leftShift), 
  new StartCardShort(3, CardFuncEnums.prodToBack)
  ], 
  [1, 1, 1, 10, 10, 10]);

const level15_dup3 = new LevelConfig([
  new StartCardShort(2, CardFuncEnums.duplicate),
  new StartCardShort(1, CardFuncEnums.addToFront),
  new StartCardShort(1, CardFuncEnums.rightShift),
  new StartCardShort(1, CardFuncEnums.prodToBack),
  new StartCardShort(1, CardFuncEnums.duplicate),
  ], 
  [2, 2, 1, 1, 1, 1, 1, 1, 1, 1]);

const level16_mod1 = new LevelConfig([
  new StartCardShort(1, CardFuncEnums.addToFront),
  new StartCardShort(2, CardFuncEnums.addToFront),
  new StartCardShort(5, CardFuncEnums.moduloVal),
  new StartCardShort(5, CardFuncEnums.addToFront),
  new StartCardShort(6, CardFuncEnums.addToFront),
  new StartCardShort(7, CardFuncEnums.addToFront),
  ], 
  [0,0,1]);

const level17_mod2 = new LevelConfig([
  new StartCardShort(1, CardFuncEnums.prodToBack),
  new StartCardShort(3, CardFuncEnums.prodToBack),
  new StartCardShort(3, CardFuncEnums.moduloVal),
  new StartCardShort(2, CardFuncEnums.addToFront),
  new StartCardShort(1, CardFuncEnums.addToFront),
  ], 
  [0,0]);

const level18_mod3 = new LevelConfig([
  new StartCardShort(87, CardFuncEnums.identity),
  new StartCardShort(2, CardFuncEnums.duplicate),
  new StartCardShort(19, CardFuncEnums.identity),
  new StartCardShort(42, CardFuncEnums.moduloVal),
  ], 
  [NaN, NaN, NaN, NaN]);
  

const finLevel = new LevelConfig([
  new StartCardShort(2, CardFuncEnums.rightShift),
  new StartCardShort(2, CardFuncEnums.addToFront),
  new StartCardShort(2, CardFuncEnums.identity),
  new StartCardShort(2, CardFuncEnums.duplicate),

  new StartCardShort(2, CardFuncEnums.prodToBack),
  new StartCardShort(3, CardFuncEnums.moduloVal),
  new StartCardShort(2, CardFuncEnums.leftShift),

  new StartCardShort(3, CardFuncEnums.whereLess),
  new StartCardShort(1, CardFuncEnums.duplicate),
],
  ['F', 'I', 'N']
  );


/*
const playgroundLevel = new LevelConfig([
  new StartCardShort(1, CardFuncEnums.identity),
  new StartCardShort(2, CardFuncEnums.leftShift),
  new StartCardShort(3, CardFuncEnums.rightShift),
  new StartCardShort(4, CardFuncEnums.addToFront),
  new StartCardShort(5, CardFuncEnums.prodToBack),
  new StartCardShort(3, CardFuncEnums.whereLess),
  new StartCardShort(3, CardFuncEnums.whereGreater),
  new StartCardShort(4, CardFuncEnums.moduloVal),
  new StartCardShort(2, CardFuncEnums.duplicate),
], 
  [6,5]);
*/

/*
const sampleLevel = new LevelConfig([
  new StartCardShort(2, CardFuncEnums.prodToBack),
  new StartCardShort(5, CardFuncEnums.identity),
  new StartCardShort(1, CardFuncEnums.duplicate),
  new StartCardShort(2, CardFuncEnums.rightShift),
  new StartCardShort(1, CardFuncEnums.addToFront),
  ], 
  [2,2,5,5]);
*/

const levels = [
  level0, level1,
  level2_firstProd, level2_secondProd,
  level3_shiftOne, level4_shiftTwo_2, level6_shift4_again, level5_shift3_2,
  level7_negs, level8_negs2,
  level9_id1, level10_id2,
  level11_where1, level12_where2,
  level13_dup1, level14_dup2, level15_dup3,
  level16_mod1, level17_mod2, level18_mod3,

  finLevel];

export { LevelConfig, levels};